export * from '@fhs/routing/src/routes/(drawer)/account/payment/add-card';
export { default } from '@fhs/routing/src/routes/(drawer)/account/payment/add-card';
